import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { environment } from '@env/environment';

import { RatingAuthInterceptor } from './rating.interceptor';
import { API_BASE_URL, Service } from './ratingApi';

@NgModule({
  imports: [CommonModule],
  declarations: [],
  providers: [
    Service,
    {
      provide: API_BASE_URL,
      useValue: `${environment.api.brasilprev.url}`
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RatingAuthInterceptor,
      multi: true
    }
  ],
  exports: []
})
export class RatingApiModule {}
